import React, {FC, useEffect, useState} from "react";
import {Button, Dropdown, Modal, notification, Table} from "antd";
import {IGetUsersProps, IUser} from "../admin-users.type";
import {getDeletedUsers, restoreDeletedUser} from "../actions";
import DotsIcon from "../../manage-reestr-item/dots.svg";
import {TablePaginationConfig} from "antd/lib/table/interface";
import UserSearchFilter from "../search-forms/user-search-filter";

const DeletedUserList: FC<IGetUsersProps> = (props: IGetUsersProps) => {
    const [users, setUsers] = useState<IUser[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isAction, setIsAction] = useState<number>();
    const [pagination, setPagination] = useState<any>({
        current: 1,
        pageSize: 50,
    });
    const [filterData, setFilterData] = useState({});
    const [current, setCurrent] = useState(1);

    const items = [
        {
            label: 'Восстановить',
            key: '1',
        }
    ];

    const columns = [
        {
            title: 'Id',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: 'ФИО',
            dataIndex: 'fio',
            key: 'fio',
            render: (_, x) => `${x.lastName} ${x.firstName}`
        },
        {
            title: 'E-mail',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'E-mail подтвержден',
            dataIndex: 'emailConfirmed',
            key: 'emailConfirmed',
            render: x => x ? 'Да' : 'Нет',
        },
        {
            title: 'Телефон',
            dataIndex: 'phoneNumber',
            key: 'phoneNumber',
        },
        {
            title: 'Телефон подтвержден',
            dataIndex: 'phoneConfirmed',
            key: 'phoneConfirmed',
            render: x => x ? 'Да' : 'Нет',
        },
        {
            title: 'ИИН',
            dataIndex: 'taxpayerCode',
            key: 'taxpayerCode',
        },
        {
            title: 'Действия',
            dataIndex: 'id',
            key: 'actions',
            render: (id) => (
                <Dropdown menu={{ items, onClick: ({ key }) => onClick(key, id) }} trigger={['click']}>
                    <Button className="p-0" shape="round" icon={<DotsIcon />} loading={isAction === id} />
                </Dropdown>
            ),
        }
    ];

    const restoreUser = (id: number) => {
        Modal.confirm({
            content: 'Вы действительно хотите восстановить пользователя?',
            onOk() {
                setIsAction(id);

                restoreDeletedUser(id).then(
                    () => {
                        notification['success']({
                            message: 'Пользователь успешно восстановлен!',
                        });
                        loadData();
                    }
                ).finally(() => setIsAction(null));
            }
        });
    };

    const onClick = (key: string, id: number) => {
        switch (key) {
            case '1': restoreUser(id); break;
        }
    };

    const loadData = (values?: any) => {
        setIsLoading(true);

        const cleanData = values || filterData;

        const params = {
            page: pagination.current - 1,
            size: pagination.pageSize,
            sort: 'id,desc',
            ...cleanData
        };

        getDeletedUsers(params).then(
            value => {
                setUsers(value.data.content);
                setPagination({
                    ...pagination,
                    total: value.data.totalElements

                });
            }
        ).finally(() => setIsLoading(false));
    };

    const handleTableChange = (pagination: TablePaginationConfig) => {
        setPagination(pagination);
    };

    useEffect(() => {
        if (props.activeTab === props.tabKey) {
            loadData();
        }
    }, [pagination.current, props.activeTab]);

    const onClear = (values = {}) => {
        setFilterData(values);

        if (current > 1) {
            setCurrent(1);
        } else {
            loadData(values);
        }
    };

    return (
        <>
            {props.activeTab === props.tabKey && (
                <UserSearchFilter {...props} onSearch={loadData} onClear={onClear} />
            )}

            <Table columns={columns}
                   dataSource={users}
                   className="my-3"
                   loading={isLoading}
                   pagination={pagination}
                   onChange={handleTableChange}
            />
        </>
    );
};

export default DeletedUserList;
